import { CssBaseline } from "@mui/material"
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles"
import merge from "lodash-es/merge"

import StandardTheme from "@sap/theme"
import GlobalStyles from "@sap/theme/globalStyles"

function Theme({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <StandardTheme>
      <CustomTheme>{children}</CustomTheme>
    </StandardTheme>
  )
}

export default Theme

const innerTheme = {
  palette: {
    background: {
      default: "#fff",
    },
  },
}

function CustomTheme({ children }: { children: React.ReactNode }): JSX.Element {
  const outerTheme = useTheme()

  const theme = createTheme(merge(outerTheme, innerTheme))

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
